import styled from "styled-components/macro";
import { FC } from "react";
import { CircularProgress } from "@material-ui/core";

const Block = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80%;
  width: 100%;
`

type PropsType = {
  children: JSX.Element,
  loading: boolean,
  height?: number
}

const Loading: FC<PropsType> = ({
      children,
      loading,
      height
}) => {
  return loading ? (
    <Block style={{height: height + 'px'}}>
      <CircularProgress color="secondary" />
    </Block>
  ) : children;
}

export default Loading